module.exports = __webpack_public_path__ + "img/gz.474ff992.png";